import config from "../config.js";
import RequestManager from "./request.js";

export default class Acte {
    static async getInfosActeNGAP(codeActe) {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}Actes/getInfosActeNGAP?codeActe=${codeActe}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération des données du code acte : ", error);
            throw error;
        }
    }

    static async postOkActeNGAP(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Actes/postOkActeNGAP`, data);
            return response;
        } catch (error) {
            console.error("Erreur lors de la validation de l'acte : ", error);
            throw error;
        }
    }

    static async getInfoActeCCAM(codeActe) {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}Actes/getInfoActeCCAM?codeActe=${codeActe}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération des données du code acte : ", error);
            throw error;
        }
    }

    static async getListeChoixCCAM(codeActe, date, activite) {
        try {
            const url = `${config.urlBackEnd}Actes/getListeChoixCCAM?codeActe=${encodeURIComponent(codeActe)}&date=${encodeURIComponent(date)}&activite=${encodeURIComponent(activite)}`;
            const response = await RequestManager.get(url);
            return response;
        } catch (error) {
            console.error("Erreur lors de la recuperation des listes de choix CCAM : ", error);
            throw error;
        }
    }

    static async getCodeActe() {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}Actes/getCodeActe`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération de la liste des actes CCAM : ", error);
            throw error;
        }
    }

    static async postSupprimeActeCCAM(codeActe, prix) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Actes/postSupprimeActeCCAM?codeActe=${codeActe}&prix=${prix}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la suppression de l'acte CCAM : ", error);
            throw error;
        }
    }

    static async postEnregistrerActeCCAM(acte) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}Actes/postEnregistrerActeCCAM`, acte);
            return response;
        } catch (error) {
            console.error("Erreur lors de l'enregistrement de l'acte CCAM : ", error);
            throw error;
        }
    }
}
